module.exports = __webpack_public_path__ + "static/media/19.cdb51ea6.jpg";